import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { useJsonLd } from "@/lib/use-json-ld";

const FAQS = [
  {
    q: "Co je Draconia RP?",
    a: "Draconia RP je online RolePlay server pro World of Warcraft, postavený na enginu WoW 3.3.5a. Namísto klasického WoW lore je zasazený do světa Forgotten Realms a řízený mechanikami D&D 5E - je to WoW RolePlay projekt zaměřený na společné vyprávění příběhů, ne na endgame raidy.",
  },
  {
    q: "Je Draconia RP zdarma?",
    a: "Ano, Draconia RP je bezplatný online RP server. Registrace vytváří skutečný herní účet a hraní nic nestojí - žádné poplatky, žádný pay-to-win.",
  },
  {
    q: "Čím se WoW RP server liší od klasického private serveru?",
    a: "Na Draconia RP se neleveluje ani negrinduje - důraz je na RolePlay, ne na výkon postavy. Pravidla přebírají mechaniky D&D 5E, svět je Forgotten Realms a server je silně namodovaný, aby ctil D&D lore i pravidla místo standardního WoW obsahu.",
  },
  {
    q: "Je Draconia RP česká komunita?",
    a: "Ano, jde o online CZ RolePlay komunitu - komunikace, eventy i podpora probíhají v češtině. Pokud hledáš WoW RolePlay server v češtině, Draconia RP je přesně pro tebe.",
  },
  {
    q: "Jaký klient a patch potřebuji?",
    a: "Draconia RP běží na patchi WoW 3.3.5a (Wrath of the Lich King). Postup instalace a připojení najdeš v sekci Jak hrát výše na stránce.",
  },
  {
    q: "Jak se připojím a začnu hrát?",
    a: "Stačí si zdarma vytvořit herní účet přes tlačítko Registrace, stáhnout klienta WoW 3.3.5a a přihlásit se. Detailní návod krok za krokem najdeš v sekci Jak hrát.",
  },
];

export const FAQ = () => {
  useJsonLd({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  });

  return (
    <section id="faq" className="relative scroll-mt-20 px-6 py-16 lg:py-20" data-testid="faq-section">
      <div className="mx-auto max-w-[900px]">
        <Reveal className="mb-12 text-center">
          <p className="font-display text-xs font-600 uppercase tracking-[0.3em] text-[#F0801F]">
            Časté dotazy
          </p>
          <h2 className="mt-3 font-display text-3xl font-600 uppercase tracking-tight text-white sm:text-4xl">
            Než se zeptáš na Discordu
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="rounded-xl border border-white/10 bg-[#17171b] px-6 sm:px-10">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-display text-sm font-600 uppercase tracking-[0.04em] text-white hover:text-[#F0801F] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-white/60">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
